<div style="display: flex; flex-direction: row; gap: 0.5em; padding: 0.2em;">
  <app-button
    *ngFor="let action of actions"
    [btnType]="action.btnType"
    [title]="action.title"
    [task]="action.task"
    [iconType]="action.iconType"
  ></app-button>
</div>
